<template>
  <div>
    <div class="flex center m-10" v-if="showFilter">
      <el-radio-group v-model="invoiceFilter" size="small" @change="handleFilterChange">
      <el-radio-button label="paid">Payé</el-radio-button>
      <el-radio-button label="notPaid">Non payé</el-radio-button>
      <el-radio-button label="all">Tout</el-radio-button>
    </el-radio-group>
    </div>
    <div class="flex center m-10" v-if="paging">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="totalPages"
        @click-previous="fetchPreviousPage"
        v-if="paging && isNotEmpty"
        @click-next="fetchNextPage" />
    </div>
    <div class="hidden-md-and-down">
      <el-table
        :data="invoices"
        stripe
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :cell-style="{padding:'2px'}"
        @sort="handleSorting"
        v-loading="invoicesLoading">
        <div slot="empty">
          <span>{{$t('invoices.noInvoices')}}</span>
        </div>
        <el-table-column
          type="selection"
          :selectable="canBePaid"
          width="50">
        </el-table-column>
        <el-table-column type="expand" v-if="showDetails">
          <template slot-scope="props">
            <span v-if="props.row.payments.length==0">Aucun paiement</span>
            <PaymentInvoiceCard v-for="payment in props.row.payments" :key="payment.id" :payment="payment"></PaymentInvoiceCard>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.invoiceNumber')" prop="inv_number" :show-overflow-tooltip="true" width="200">
          <template slot-scope="scope">
            <status-indicator class="mr-10" :negative="showRedFlag(scope.row)" :positive="showGreenFlag(scope.row)" pulse/>
            <el-link @click="openInvoice(scope.row.id)">{{scope.row.inv_number}}</el-link> <el-link :href="'/invoices/'+scope.row.id" target="_blank" :underline="false"><i class="mdi mdi-launch ml-10"></i></el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.invoiceDate')" :sortable="sortable && !paging" prop="date" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{_moment(scope.row.date)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.amount')" :sortable="sortable && !paging" prop="total" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{$n(scope.row.total,'currency', scope.row.currency.code)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.outstanding')" :sortable="sortable && !paging" prop="balance.outstanding" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{$n(scope.row.balance.outstanding,'currency', scope.row.currency.code)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.dueDate')" :sortable="sortable && !paging" prop="due_date" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status.code!=='DRAFT' && scope.row.due_date != null">{{_moment(scope.row.due_date)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.paidAt')"  :sortable="sortable && !paging" prop="paid_at" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.paid_at != null">{{_moment(scope.row.paid_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.status')" prop="status" w>
          <template slot-scope="scope">
            <el-tag :type="getInvoiceTagType(scope.row.status)" style="margin-left:10px;">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="pay" :disabled="selectedInvoices.length==0">{{$t('invoices.addPayment')}}</el-button>
        <el-button @click="toggleSelection()">{{$t('customer_portal.Unselect')}}</el-button>
      </div>
      <AddPaymentsDialog :visible="addPaymentsDialogVisible" :invoices="selectedInvoices" direction="rtl" @close="closeAddPaymentsDialog"  @paid="updateInvoicePayment" :customerId="parseInt(customerId)"></AddPaymentsDialog>
    </div>
    <div class="hidden-lg-and-up">
      <div v-for="inv in invoices" :key="inv.id">
        <InvoiceTile @click="openInvoice(inv.id)" :customer="inv.customer" :inv_number="inv.inv_number" :reference="inv.reference" :date="inv.date" :total="inv.total" :status="inv.status" :files="inv.files" :currency="inv.currency"></InvoiceTile>
        <el-divider />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import invoiceAPI from '@/services/API/invoice';
import PaymentInvoiceCard from '@/components/invoice/invoice-payment-card.vue'
import AddPaymentsDialog from '@/components/payments/add-payments-dialog.vue'
import InvoiceTile from '@/components/invoice/Invoice-tile'
import Pagination from '@/components/pagination'

export default {
  name: 'invoice-table',
	props: {
    customerId : {
      type : String,
      default : null
    },
    salesOrderId : {
      type : Number,
      default: null
    },
    purchaseOrderId : {
      type : Number,
      default: null
    },
    sortable : {
      type : Boolean,
      default : false
    },
    filter : {
      type : Object,
      default : null
    },
    admin : {
      type: Boolean,
      default : false
    },
    showDetails : {
      type : Boolean,
      default:true
    },
    sortingOrder: {
      type: String,
      default: 'date',
    },
    sortingDirection: {
      type: String,
      default: 'ASC'
    },
    paging: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 25,
    },
    showFilter: {
      type: Boolean,
      default: false,
    },
	},
  data() {
    return {
      invoices : [],
      invoicesLoading : false,
      selectedInvoices : [],
      addPaymentsDialogVisible : false,
      totalPages: null,
      page: 1,
      invoiceFilter: 'all',
    };
  },components: {
    PaymentInvoiceCard,
    AddPaymentsDialog,
    InvoiceTile,
    Pagination,
  },
  watch : {
    customerId : function(newVal, oldVal){
      if(newVal!=oldVal){
          this.fetchInvoices();
      }
    },
    salesOrderId : function(newVal, oldVal){
      if(newVal!=oldVal){
          this.fetchInvoices();
      }
    },
    purchaseOrderId : function(newVal, oldVal){
      if(newVal!=oldVal){
          this.fetchInvoices();
      }
    }
  },
	methods: {
    handleFilterChange(){
      this.fetchInvoices();
    },
    fetchNextPage () {
      if (this.page < this.totalPages) {
          this.page += 1;
          this.fetchInvoices();
        }
    },
    fetchPreviousPage () {
      if (this.page > 1) {
        this.page -= 1;
        this.fetchInvoices();
      } 
    },
    handleSorting (prop, order) {
      // console.log(prop);
      // console.log(order);
    },
    updateInvoicePayment(){
      this.fetchInvoices();
    },
    closeAddPaymentsDialog(){
      this.addPaymentsDialogVisible=false;
    },
    handleSelectionChange(val){
			this.selectedInvoices = val;
		},
    pay(){

      this.addPaymentsDialogVisible = true;
    },
    toggleSelection(rows) {

      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        if(this.$refs.multipleTable){
          this.$refs.multipleTable.clearSelection();
        }else{
          _.forEach(this.invoices, inv=>{inv.selected=false;})
        }
      }
    },
    canBePaid(row, index){
      if(this.invoices[index].status.code!="PAID" && this.invoices[index].status.code!="VOIDED"){
          let CC_payment_option = _.find(this.invoices[index].paymentOptions, paymentOption=>{return paymentOption.code==="CREDIT_CARD"})
          return CC_payment_option!=null || this.isAdminPanel
      }
      return false;
		},
    openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
      this.$router.push(index);
    },
    fetchInvoices(){
      let params = {};
      params.customerId = this.customerId?this.customerId:undefined;
      params.salesOrderId = this.salesOrderId?this.salesOrderId:undefined;
      params.purchaseOrderId = this.purchaseOrderId?this.purchaseOrderId:undefined;
      params.orderBy = this.sortingOrder;
      params.direction = this.sortingDirection;
      
     

      if (this.paging) {
        params.paging = this.paging;
        params.limit = this.perPage;
        params.page = this.page;
      } else {
        params.paging='no';
      }

      if (this.invoiceFilter === 'paid') {
        params.statusCode = 'PAID';
      } else if (this.invoiceFilter === 'notPaid') {
        params.statusCode = ['SENT', 'DRAFT', 'PARTIALLY_PAID'];
      }
      else if(this.filter!=null && this.filter.statusCode!=null){
        params.statusCode = this.filter.statusCode;
      }
      
      this.invoicesLoading = true;
      invoiceAPI.fetchInvoices(params)
        .then(invoices=>{
          if (this.paging) {
            this.invoices= invoices.list;
            this.totalPages = invoices.pages;
            this.invoicesLoading = false;
          } else {
            this.invoices= invoices;
            this.invoicesLoading = false;
          }
          
        })
    },
    _moment(datetime, format='L'){
      return moment(datetime).format(format);
    },
    showGreenFlag (invoice) {
      return !this.isLate(invoice) && ( _.get(invoice, 'status.code') != 'PAID' && _.get(invoice, 'status.code') != 'VOIDED' &&  _.get(invoice, 'status.code') != 'DRAFT')
    },
    showRedFlag (invoice) {
      return (this.isLate(invoice) && (_.get(invoice, 'status.code') != 'PAID' && _.get(invoice, 'status.code') != 'VOIDED'));
    },
    isLate(invoice){
      return moment(new Date).format("YYYY-MM-DD") > moment(invoice.due_date).format("YYYY-MM-DD");
		}

	},
	computed: {
    isNotEmpty(){
      return _.size(this.invoices) > 0;
    },
    isAdminPanel(){
      return this.admin==true;
    },
    ...mapGetters('invoices',['getInvoiceTagType'])

	},
  mounted(){
    this.fetchInvoices();
  }
}
</script>
<style lang="scss" scoped>




</style>
